export const required = (value, options) => {
  if (value === void 0 || value === null) {
    return false;
  }
  if (value.constructor === Array) {
    return !!value.length;
  }
  if (typeof value === "boolean") {
    return options.invalidateFalse ? !!value : true;
  }
  return !!String(value).trim().length;
};
